import { Injectable } from '@angular/core';
import { environment } from "../../../../../environments/environment";
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

export interface PartSubscriberRequest {
  phone?: string;
  email?: string;
  part?: number;
  consent: boolean;
  consent_text?: string;
  subscriber_id?: number;
}

export interface PartSubscriberResponse {
  subscriber_id: number;
  phone: string | null;
  email: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class PartSubscriberService {
  private apiBase = environment.apiBase;
  private readonly endpoint = '/part-subscribers';
  private readonly subscriberIdKey = 'cp_subscriber_id';

  constructor(private http: HttpClient) {}

  subscribe(data: PartSubscriberRequest): Observable<PartSubscriberResponse> {
    const subscriberId = this.getSubscriberId();

    const body: PartSubscriberRequest = {
      ...data,
      ...(subscriberId !== null ? { subscriber_id: subscriberId } : {})
    };

    return this.http
      .post<PartSubscriberResponse>(`${this.apiBase}${this.endpoint}`, body)
      .pipe(
        tap(response => {
          this.saveSubscriberId(response.subscriber_id);
        })
      );
  }

  getSubscriberId(): number | null {
    const value = localStorage.getItem(this.subscriberIdKey);

    if (!value) {
      return null;
    }

    const id = Number(value);

    return Number.isNaN(id) ? null : id;
  }

  private saveSubscriberId(id: number): void {
    localStorage.setItem(this.subscriberIdKey, String(id));
  }
}